import { render, staticRenderFns } from "./CLogo.vue?vue&type=template&id=db48aa6a&scoped=true&"
import script from "./CLogo.vue?vue&type=script&lang=js&"
export * from "./CLogo.vue?vue&type=script&lang=js&"
import style0 from "./CLogo.vue?vue&type=style&index=0&id=db48aa6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db48aa6a",
  null
  
)

export default component.exports